import React from "react";
import Modal from "react-native-modal";
import ResponsiveContent from "../shared/responsive-content";
import { View, Pressable, Text } from "react-native";
import CloseIcon from "@/assets/svgs/close-icon";
import { Button } from "../ui/button";

function ReportSubmittedModal({
  isVisible,
  onClose,
}: {
  isVisible: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      onDismiss={onClose}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent>
        <View className="mx-4 bg-teachLoop-creamBase rounded-xl px-8 py-10">
          <View className="items-end">
            <Pressable
              onPress={onClose}
              className="active:opacity-80"
              style={{ marginHorizontal: -12 }}
            >
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>
          <View className="gap-8">
            <Text className="font-zilla-slab-medium font-medium text-[28px] leading-[1.2] text-black">
              Report submitted! Your payment is processing..
            </Text>
            <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
              Thanks for submitting the report. Your payment is now being
              processed. Check your Loopedin wallet after 15 minutes to see the
              payment.
            </Text>
            <Button fullWidth size="md" intent="primary" onPress={onClose}>
              <Button.Text size="md">Got it</Button.Text>
            </Button>
          </View>
          <View className="h-3" />
        </View>
      </ResponsiveContent>
    </Modal>
  );
}

export default ReportSubmittedModal;
